import { defineMessages } from "react-intl";
export const messages = defineMessages({
    dedupeUnitsSearch: {
        id: "dedupeUnits.search.placeholder",
        defaultMessage: "Search by Community Name",
    },
});
